module.exports = __webpack_public_path__ + "static/media/notebook.d58c5099.svg";